// @ts-nocheck
import { immerable } from "immer";
import { emptyCompoundId } from "../../../connections/models";
import { VendorDataCollection } from "../../../vendor-data/models";
import { type LensCompoundIdModel } from "../../models";

export class LensModel {
    public [immerable] = true;
    public readonly compoundId: LensCompoundIdModel = emptyCompoundId;
    public readonly vendorData = new VendorDataCollection([]);
    public readonly name: string | null = null;
    public readonly iconUrl: string | null = null;
    public readonly previewUrl: string | null = null;
    public readonly updatedAt: Date | null = null;
    public readonly hasMusic: boolean;
    public readonly lensSource: string;
    public readonly videoUrl: string;
    public readonly previewWebpUrl: string;
}
